import { mixins, styled } from '@bob/library'

export const Wrapper = styled.div`
  flex-shrink: 0;
`

export const SubtotalWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid ${({ theme }: { theme: any }) => theme.color.grayLight};
  width: 100%;
  ${mixins.media.max.height(750)} {
    padding-top: 20px;
    padding-bottom: 20px;
  }
`

export const SubtotalLabel = styled.div``

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 15px;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
  padding-top: 35px;
  padding-bottom: 35px;
`
